"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UvApiAuth_1 = __importDefault(require("./UvApiAuth"));
var Help_1 = __importDefault(require("./Help"));
var WebsitesApi = /** @class */ (function (_super) {
    __extends(WebsitesApi, _super);
    function WebsitesApi() {
        return _super.call(this) || this;
    }
    //unused?
    WebsitesApi.prototype.getAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/all")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    //POIS Wiz
    WebsitesApi.prototype.textSearch = function (lat, lng, radius, keyword) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/text-search/" + lat + "/" + lng + "/" + radius + "/" + keyword)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getPois = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-pois/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getWebsiteStreetView = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-street-view/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getWebsiteAmenities = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-amenities/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getWebsiteAmenity = function (buildingId, amenityId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-amenity/" + buildingId + "/" + amenityId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getWebsiteVisitorProcess = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-visitor-process/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getWalk = function (buildingId, poiId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-walk/" + buildingId + "/" + poiId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getPlaceDetails = function (googlePlaceId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-place-details/" + googlePlaceId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.reverseGeocode = function (poiId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-address/" + poiId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getTflAddress = function (tflId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-tfl-address/" + tflId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getPlacesAddress = function (poiId, keyword, radius) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-places-address/" + poiId + "/" + encodeURI(keyword) + "/" + radius)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    //async getDbPois(buildingId: number) {
    //    return await this.instance.get(`/admin/pois/${buildingId}`);
    //} think unused
    WebsitesApi.prototype.getTflLineStatus = function (tflId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/sites/api/get-station-lines-status?tflId=" + tflId)];
                    case 1: return [2 /*return*/, _a.sent()]; //TODO:
                }
            });
        });
    };
    WebsitesApi.prototype.getTflBikeStatus = function (tflId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/sites/api/get-bike-rack-status?bikeRackId=" + tflId)];
                    case 1: return [2 /*return*/, _a.sent()]; //TODO:
                }
            });
        });
    };
    //Website Wiz //Website Wiz//Website Wiz//Website Wiz
    WebsitesApi.prototype.getWebsite = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.getWebsiteTenants = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.get("/websites/get-tenants/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    //MUTATIONS
    WebsitesApi.prototype.createInvoice = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/create-invoice/" + buildingId, null, { responseType: 'blob' })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    //See comments in backend. keep this for later (final Admin webWiz UI version)
    //async approveWebsite(buildingId: number) {
    //    return await this.instance.post(`/websites/approve/${buildingId}`);
    //}
    WebsitesApi.prototype.upsertAmenities = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/upsert-amenities", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.upsertVisitorProcess = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/upsert-visitor-process", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.upsertTenants = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/upsert-tenants", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.upsertPois = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/upsert-pois", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.upsertPoisAndCalc = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/upsert-pois-and-calc", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.upsertStreetView = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/upsert-street-view", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.saveWebsite = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/save", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.sendApproval = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/send-approval", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.goLive = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/go-live", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.sendTenantWelcome = function (objData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/send-tenant-welcome", Help_1.default.deepCloneObject(objData))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.seedBuilding = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/seed-building/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.seedGlobal = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/seed-global")];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WebsitesApi.prototype.deleteBuildingsFiles = function (buildingId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.instance.post("/websites/delete-files/" + buildingId)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return WebsitesApi;
}(UvApiAuth_1.default));
exports.default = WebsitesApi;
//# sourceMappingURL=WebsitesApi.js.map